// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthorized-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
  }
  
  .unauthorized-content__icon {
    font-size: 70px;
    margin-bottom: 3rem;
  }
  
  .unauthorized-content__message {
    /* Any text styles specific to this message can go here */
  }
  `, "",{"version":3,"sources":["webpack://./src/features/deal/subFeatures/dealTabs/tabsContainer/UnauthorizedContent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yDAAyD;EAC3D","sourcesContent":[".unauthorized-content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 80vh;\n  }\n  \n  .unauthorized-content__icon {\n    font-size: 70px;\n    margin-bottom: 3rem;\n  }\n  \n  .unauthorized-content__message {\n    /* Any text styles specific to this message can go here */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
